export interface IPartnersListData {
  alt: string;
}
export const PartnersListData: IPartnersListData[] = [
  { alt: 'black-bone' },
  { alt: 'transport' },
  { alt: `kfc` },
  { alt: 'colizeum' },
  { alt: 'cofe-house' },
  { alt: 'cofe-wake' },
  { alt: 'beeline' },
  { alt: 'myata' },
  { alt: 'pp' },
  { alt: 'choko' },
  { alt: 'sovcom' },
  { alt: 'worldclass' },
  { alt: 'bsb' },
  { alt: 'ozon' },
  { alt: 'yakitoriya' },
  { alt: 'metro' },
  { alt: 'pedant' },
  { alt: 'hookah' },
  { alt: 'yota' }
];
